import { useSyncExternalStore } from 'react';
import { loadFairnessEnabled, subscribeFairnessEnabled } from './enabled';

/** Reactive read of the operator's provably-fair flag; false until design_system resolves. */
export function useFairnessEnabled(): boolean {
  return useSyncExternalStore(subscribeFairnessEnabled, loadFairnessEnabled, () => false);
}
